import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
// import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import Logout from "@mui/icons-material/Logout";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import {
  AppBarButton,
  SearchIconWrapper,
  StyledInputBase,
  useStyles,
  NavIconButtonWrapper,
} from "./appbar-styles";
import { uiActions } from "../../../store/ui-slice";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import { useNavigate } from "react-router-dom";
import { useTheme, useMediaQuery, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { themeActions } from "../../../store/theme-slice";

export default function PrimarySearchAppBar(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const isDarkMode = useSelector((state) => state.theme.isDarkMode);
  // const showDrawer = useSelector((state) => state.ui.showDrawer);
  // const theme = useTheme();
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const onLogOutClickHandler = (e) => {
    navigate("/login");
  };

  const onDarkModeHandler = (event) => {
    dispatch(themeActions.toggleTheme());
  };

  const onClickChangePalette = (event) => {
    dispatch(
      themeActions.toggleCustomTheme({
        customPaletteNum: Math.floor(Math.random() * 6),
      })
    );
  };

  const toggleDrawerHandler = (event) => {
    if (isMediumScreen) {
      dispatch(uiActions.toggleDrawer());
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        elevation={0}
        position="sticky"
        // position="fixed"
        className={classes.appbar}
        color="inherit"
      >
        <Toolbar>
          {isMediumScreen && (
            <Toolbar className={classes.toolbar}>
              <Typography variant="h6">React Dashboard</Typography>
              <Box sx={{ flex: 3 }}></Box>

              <Button onClick={toggleDrawerHandler}>
                <MenuOutlinedIcon />{" "}
              </Button>
            </Toolbar>
          )}

          <Box className={classes.search}>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
            
              placeholder="Search here…"
              inputProps={{ "aria-label": "search" }}
            />
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          <Box
            className={classes.appbarIconContainer}
            sx={{ display: { xs: "none", md: "flex" } }}
          >
            <NavIconButtonWrapper
              size="large"
              aria-label="show 4 new mails"
              color="inherit"
              onClick={onClickChangePalette}
            >
              {/* <Badge badgeContent={4} color="error"> */}
              <StarBorderOutlinedIcon />
              {/* </Badge> */}
            </NavIconButtonWrapper>

            <NavIconButtonWrapper
              size="large"
              aria-label="show 4 new mails"
              color="inherit"
            >
              {/* <Badge badgeContent={4} color="error"> */}
              <NotificationsActiveOutlinedIcon />
              {/* </Badge> */}
            </NavIconButtonWrapper>

            <NavIconButtonWrapper
              size="large"
              aria-label="show 4 new mails"
              color="inherit"
              onClick={onDarkModeHandler}
            >
              {/* <Badge badgeContent={4} color="error"> */}
              <DarkModeOutlinedIcon />
              {/* </Badge> */}
            </NavIconButtonWrapper>

            <NavIconButtonWrapper
              size="large"
              aria-label="show 4 new mails"
              color="inherit"
            >
              {/* <Badge badgeContent={4} color="error"> */}
              <ChatBubbleOutlineOutlinedIcon />
              {/* </Badge> */}
            </NavIconButtonWrapper>

            <Box m={2} mx={5} >
              <AppBarButton
                variant="contained"
                size="large"
                onClick={onLogOutClickHandler}
                startIcon={<Logout />}
              >
                Log Out
              </AppBarButton>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      {props.children}
    </Box>
  );
}
